import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ProblemSection from "./components/ProblemSection";
import WhyHumanLed from "./components/WhyHumanLed";
import HowItWorks from "./components/HowItWorks";
import Services from "./components/Services";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import CartSummary from "./components/CartSummary";
import Confirmation from "./pages/Confirmation";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ProblemSection />
      <WhyHumanLed />
      <HowItWorks />
      <Services />
      <FAQ />
      <Footer />
      <CartSummary />
    </div>
  );
};

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/confirmation" element={<Confirmation />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </CartProvider>
  );
}

export default App;
